import { BasicEvent } from "./BasicEvent";
export class ArbetsorderPeriodsattPeriodUpdatedMessage extends BasicEvent {
    arbetsorderId: number;
    periodsattPeriod?: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "ArbetsorderPeriodsattPeriodUpdatedMessage";
    constructor() {
        super(ArbetsorderPeriodsattPeriodUpdatedMessage.$type);
    }
}
